export default "__VITE_ASSET__Dz0A0xey__"